var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 0C13.8792 0 0 13.8792 0 31C0 48.1208 13.8792 62 31 62C48.1208 62 62 48.1208 62 31C61.9818 13.8868 48.1133 0.0182938 31 0ZM31 57.5715C16.325 57.5715 4.42853 45.675 4.42853 31C4.42853 16.325 16.325 4.42853 31 4.42853C45.675 4.42853 57.5715 16.325 57.5715 31C57.5556 45.6685 45.6685 57.5556 31 57.5715Z",
    fill: "#95BF53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0123 18.3618C47.1542 17.533 45.7939 17.533 44.9359 18.3618L24.3584 38.9392L17.0667 31.6474C16.2171 30.7678 14.8153 30.7435 13.9357 31.5931C13.0561 32.4426 13.0318 33.8445 13.8814 34.7241C13.8992 34.7425 13.9173 34.7606 13.9357 34.7784L22.7929 43.6356C23.6575 44.5001 25.0593 44.5001 25.9239 43.6356L48.0668 21.4927C48.9164 20.6131 48.892 19.2114 48.0123 18.3618Z",
    fill: "#95BF53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.52d8232ce32af0e8a315399324185f37.svg";
export { ForwardRef as ReactComponent };